import { Dispatch, SetStateAction, useState } from "react";
import { useDebounce } from "./useDebounce";

export function useDelayedToggle({initialState = false, delay = 100, isImmediateFalse = false }): RetVal {
  const [isToggled, setIsToggled] = useState(initialState);
  const isToggledDebounced = useDebounce(isToggled, delay);

  return ({
    isToggled: isImmediateFalse ? (isToggledDebounced && isToggled) : isToggledDebounced,
    setIsToggled,
    handleMouseEnter: () => setIsToggled(true),
    handleMouseLeave: () => setIsToggled(false),
  })
}

type RetVal = {
  isToggled: boolean;
  setIsToggled: Dispatch<SetStateAction<boolean>>;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
}